/**
 * arrowBtn.jsx
 *
 * @Author: apple
 * @Date: 2017/10/10 16:46
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * @ignore
 * */
class ArrowBtn extends React.PureComponent {
    static propTypes = {
        arrowDisplay: PropTypes.bool,
        direction: PropTypes.string,
    };

    componentDidMount() {
        const { imgWidth, arrowClick, direction } = this.props;
        let ref = 'prevBtn';
        let movePace = imgWidth;
        let nextBool = false;
        if (direction === 'right-arrow') {
            ref = 'nextBtn';
            movePace = -imgWidth;
            nextBool = true;
        }
        this[ref].onclick = () => {
            arrowClick(movePace, nextBool);
        };
    }

    render() {
        const { arrowDisplay, direction } = this.props;
        const ref = direction === 'left-arrow' ? 'prevBtn' : 'nextBtn';
        return (
            <div className={`${direction}-container`} ref={e => (this[ref] = e)}>
                {arrowDisplay && <div className={classNames('arrow', direction)} />}
            </div>
        );
    }
}

export default ArrowBtn;



// WEBPACK FOOTER //
// ./src/carousel/ArrowBtn.jsx